import { metrics } from "../../data/building";
import { useCountUp } from "../../hooks/useCountUp";
import Container from "../ui/Container";

function MetricItem({ metric }) {
  const { ref, value } = useCountUp(metric.value);
  const displayValue = metric.value > 10 ? value.toLocaleString("en") : value;

  return (
    <div ref={ref} className="border-t border-border/80 pt-4 transition-all duration-200 ease-in-out">
      <p className="text-2xl font-semibold text-primary">
        {displayValue}
        {metric.suffix}
      </p>
      <p className="mt-1 text-sm text-secondary">{metric.label}</p>
    </div>
  );
}

function MetricsSection() {
  return (
    <section className="py-12 sm:py-16">
      <Container>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {metrics.map((metric) => (
            <MetricItem key={metric.label} metric={metric} />
          ))}
        </div>
      </Container>
    </section>
  );
}

export default MetricsSection;
